<template>
  <GwzNav />
</template>

<script>
import GwzNav from "@/components/gwzNav";
export default {
  name: "gwzHeader",
  components: { GwzNav }
};
</script>

<style scoped></style>
